/*-----------------------------------------------------------------*/
/*								商品ページで必要なjs														 */
/*-----------------------------------------------------------------*/

//------------------------------------------------------
//		ジャンプ元のアドレスがtirakitaかどうか判定
//------------------------------------------------------
var chk_jump_adr = function(menu_disp) { //v3.0
	if(menu_disp) return 1;

	//iPhoneまたは、Androidの場合は振り分けを判断
	if(chk_device() == "sumaho"){	return 1;	}

	if(!window.history.length) return 0;
	if(!document.referrer) return 0;
	if (document.referrer.match(/tirakita/i)) {
		return 0;
	}
	return 1
}


//------------------------------------------------------
//		ウィンドウのオープン
//------------------------------------------------------
function win_open(){
    w = window.open("", "newwindow");
    document.f.target = "newwindow";
}

//------------------------------------------------------
//		スパム回避
//------------------------------------------------------

function SpamDisp() {
var emailarray1022= new Array(110,97,110,100,101,109,111,95,111,107,111,116,97,101,64,116,105,114,97,107,105,116,97,46,99,111,109)
var postemail1022=''
for (i=0;i<emailarray1022.length;i++)
postemail1022+=String.fromCharCode(emailarray1022[i])

document.write('<a href="mailto:'+postemail1022+'"')

}

//------------------------------------------------------
//		レシピの画像を指定サイズに
//------------------------------------------------------
function recipe_set_img_size(cs){
	$(cs).each(function(){
		if($(this).height() > 80){
			var width = $(this).width();
			var ratio = 80 / $(this).height();
			var width = ratio * width;
			$(this).height(80);
			$(this).width(width);
		}
	});
}

jQuery.event.add(window,"load",function(){
	recipe_set_img_size(".recipe_img");
});


//------------------------------------------------------
//		レシピの画像を指定サイズに	
//------------------------------------------------------
jQuery.event.add(window,"load",function(){
	recipe_set_img_size(".recipe_img");
});


/*-------------------------------------------------
		classでグループ化されたchackboxを一択
-------------------------------------------------*/
function one_select(class_name)
{
	$(class_name).bind('click', function() {
		var now_stat = $(this).attr('checked');
		$(class_name).attr('checked','');
		if(now_stat == false)	$(this).attr('checked','');
		else									$(this).attr('checked','checked');
	});
}
/*-------------------------------------------------
		検索フォームに文字が入っているかのチェック
-------------------------------------------------*/
function form_input_chk(){
	if($('#as2_search_boxa').val()){
		$('#kensaku_form').submit();
		return true;
	}
	alert('検索語を入れてください');
	return false;
}

/*-------------------------------------------------
					評価をもっと見るバー
-------------------------------------------------*/
$(function(){
	if($("#div_hyouka2").height() > 1000){
		$("#div_hyouka2").height("1000px");

		$("#view_more").on("click", function(){
			$("#div_hyouka2").height("105%");		//単純に100%にするだけでは上手くアニメーションしない
			var newHeight = $("#div_hyouka2").height();
			$("#div_hyouka2").height("1000px");

			// Do the animation using the new fixed height.
			$("#div_hyouka2").animate({
				height: newHeight
			}, 300);
			$(this).remove(); 
		});
	}else{
		$("#view_more").css("height","0px");
		$("#view_more").css("padding","0px");
	}

});

/*-------------------------------------------------
					もっと見るバー
-------------------------------------------------*/
$(function(){
	$(".view_more").each(function(){
		if($(this).height() < 500) return;

		$(this).height("500px");
		$(this).after("<div class='view_more_button' style='color:#00F; 	cursor: pointer; font-size:1.2em;'>もっと見る<div>");

		$(window).trigger('resize');

		$(".view_more_button").bind("click", function(){
			$(this).prev("div").height("105%");		//単純に100%にするだけでは上手くアニメーションしない
			var newHeight = $(this).parent().height();
			$(this).prev("div").height("500px");

			// Do the animation using the new fixed height.
			$(this).prev("div").animate({
				height: newHeight
			}, 300);
			$(this).remove();
		});
	});
});


//-------------------------------------------------------
//	通常送料商品 or 1000円以上で送料無料
//-------------------------------------------------------
$(function(){
	$("#saiyasune").click(function(){
			$("#saiyasune2").toggle(200);
		}
	);

	$("#saiyasune").hover(function(){
			$("#saiyasune2").fadeIn(200);
		},function(){
			$("#saiyasune2").hide();
		}
	);

	/*スクロールされたらウィンドウ消す*/
	$(window).scroll(function () {
		$("#saiyasune2").hide();
	});
});

//-------------------------------------------------------
//	評価のボタン
//-------------------------------------------------------
$(function(){
	$(".hyouka_button").click(function(){
		var div_id = $(this).attr("id");
		var hyouka_id = div_id.replace(/HYOUKA_/g,"")

		var dummy = "<div id='dummy' style='display:none'></div>";
		$("body").append(dummy);


		$("#dummy").load("https://www.tirakita.com/sys/HP_Make/sankou_button_ajax.php","csrf="+$("#csrf").val()+"&hyouka_id="+hyouka_id,function(){
			console.log($("#dummy").html());
			$("#"+div_id).parent().html($("#dummy").html());
			$("#dummy").remove();
		});

	});
});

//-------------------------------------------------------
//	入荷メールを送るボタン
//-------------------------------------------------------
$(function(){
	$("#nyuuka_mail_button").click(function(){
		var num = $(this).data("goods-num");
		var id = $(this).data("goods-id");
		$("#nyuuka_mail_button_div").load("https://www.tirakita.com/sys/HP_Make/nyuuka_mail_button_ajax.php?csrf="+$("#csrf").val()+"&goods_id="+id+"&goods_num="+num);
	});
});

//-------------------------------------------------------
//	商品データの変更履歴
//-------------------------------------------------------
$(function(){
	$(".henkou_rireki").click(function(){
		$(this).next().show(500);
	});
});



//------------------------------------------------------
//	商品ページに賑わいを出すためのポップアップ
//------------------------------------------------------
$(document).ready(function(){
	//ローディングしてから30秒後くらいに出す
	//商品ページでなければ発火しない
	if($("#goods_id").html()){
		var IntervarID=setInterval(function(){
			load_cart_popup_ad_ajax();
			clearInterval(IntervarID);
		},30000);

		//ウィンドウの削除
		function del_window_after_10_sec()
		{
			$("#ajax_ad_popup").empty();
		}

		//ポップアップ画面の読み込み
		function load_cart_popup_ad_ajax()
		{
			$.ajax({ type: "GET", 	
					 url: '//www.tirakita.com/sys/popup/cart_popup_ad_ajax.php?token='+$("#token").val()+'&goods_id='+$("#goods_id").html(), 	
					 dataType: "html",
					 success : function(html)
					 {
							$("body").append(html);
					 }
			});

			var IntervarID2=setInterval(function(){
				del_window_after_10_sec();		//10秒位で削除
				clearInterval(IntervarID2);
			},5000);
		}
	}
});

//------------------------------------------------------
//	ガネーシャ君
//------------------------------------------------------
//$(document).ready(function(){
//	load_ganesh_ad_ajax();
//	GaneshIntID=setInterval(function(){
//		load_ganesh_ad_ajax();
//	},8000);
//
//	function load_ganesh_ad_ajax(){
//		$.ajax({ type: "GET", 	
//				 url: '//www.tirakita.com/sys/popup/popup_ganesh_ajax.php?goods_id='+$("#goods_id").html(), 	
//				 dataType: "html",
//				 success : function(html)
//				 {
//						$("#balloon-5-top-left").html(html);
//				 }
//		});
//	}
//});

//------------------------------------------------------
//	上部750Px写真用owl-carousel
//------------------------------------------------------
$(document).ready(function(){
	if( pluginExists( "owlCarousel" ) ){
		$('#owl').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
					items : 1 //10 items above 1000px browser width
					},
					// breakpoint from 480 up
					480 : {
					items : 1 //10 items above 1000px browser width
					},
					// breakpoint from 768 up
					768 : {
						items : 1.4, //10 items above 1000px browser width
						nav:true,
						navText: [
						"<i class='icon-chevron-left icon-white'><前へ</i>",
						"<i class='icon-chevron-right icon-white'>次へ></i>"
						]
					}
			},
			center:true,
			autoPlay: 3000, //Set AutoPlay to 3 seconds
			margin:10,
			loop:true
		});

		$('#owl2').owlCarousel({
			verticalSwiping: false,
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 1.3 //10 items above 1000px browser width
//						nav:true,
//						navText: [
//						"<i class='icon-chevron-left icon-white'><</i>",
//						"<i class='icon-chevron-right icon-white'>></i>"
//						]
					},
					// breakpoint from 480 up
					480 : {
						items : 1.4 //10 items above 1000px browser width
//						nav:true,
//						navText: [
//						"<i class='icon-chevron-left icon-white'><</i>",
//						"<i class='icon-chevron-right icon-white'>></i>"
//						]
					},
					// breakpoint from 768 up
					768 : {
						items : 1.6 //10 items above 1000px browser width
//						nav:true,
//						navText: [
//						"<i class='icon-chevron-left icon-white'><前へ</i>",
//						"<i class='icon-chevron-right icon-white'>次へ></i>"
//						]
					}
			},
			center:true,
			autoPlay: 3000, //Set AutoPlay to 3 seconds
			margin:10,
			loop:true
		});
	}

});

//------------------------------------------------------
//	縮小するパンくずリスト
//------------------------------------------------------
$(function(){
	if( pluginExists( "rcrumbs" ) ){
		//重複する文字を消す
		var prev_word_list = [];
		$("#breadcrumb a").each(function(){
			var word = $(this).html()

			if (prev_word_list.indexOf(word) >= 0){
				var org_width = $(this).parent().parent().width()
				$(this).parent().hide(300);
				$(this).parent().parent().css("width",org_width+"px");
			}else{
			}
			prev_word_list.push(word);
		});

		$(".breadcrumb").rcrumbs();

	}
});


//------------------------------------------------------
// 小さな商品写真->大きな商品写真への切り替え
//------------------------------------------------------
$(function(){

	//--------------------------------------------------------------
	//ロード時の写真の切り替え(ロード時とAjax読み込み時、両方使用している)
	//--------------------------------------------------------------
	var OnloadTopPhotoAspect = function(e) {
		var photo = $("#top_photo");
		if(photo.height() > photo.width()){
			photo.width("auto").height("100%");

			//画像のセンタリング
			var lef = ($("#top_photo_div").width() - photo.width())/2;
			photo.css("left",lef);
		}else{
			photo.width("100%").height("auto").css("left",0);
		}
		$('#top_photo').fadeIn(100);
	}
	$(window).on('load',OnloadTopPhotoAspect);
	$(window).on('load',OnloadTopPhotoAspect);

	$('#div_sentaku_load').on({
		'mouseenter':function(){

			$('#top_photo').attr("src",$(this).attr("data-href"));
			$('#top_photo').attr("data-large-img-url",$(this).attr("data-large-img-url"));

			var href = $(this).data("href");
			if(!href) href = $(this).attr("src")
			$('#top_photo_a').attr("href",href);

			$('#top_photo').attr("data-num",$(this).data("num"));
			$('#top_photo_comment').html($(this).data("txt"));

			var photo = $("#top_photo");
			if($(this).height() > $(this).width()){
				photo.width("auto").height("100%");
				//画像のセンタリング
				var lef = ($("#top_photo_div").width() - photo.width())/2;
				photo.css("left",lef);

			}else{
				photo.width("100%").height("auto").css("left",0);
			}
		}
	},'.bottom_small_photo');

//-------------------------------------
//	楽天まとめ商品で出現する画像をクリックすると、相手のデータを呼んで来る
//-------------------------------------
var load_goods_data = function(e){
	var link = $(this).data("link");
	$(this).html('<img src="https://www.tirakita.com/Gif/ajax-loader.gif">');

	link = link +' #div_sentaku_load'
	$('#div_sentaku_load').load(link,function(){
		$('#top_photo').hide();
		$('#top_photo').bind('load', OnloadTopPhotoAspect);	//ロードが終了したら呼ぶコールバック
		$('#top_photo').bind('load', function(){
			//これがないと、画面の下にくっつくお買い物かごで前の商品が選択されるバグが出る
			var href = $('.open_float_css').attr('href');
			href = href.split("&code=");
			href = href[0] + "&code=" + $('#goods_id').html();
			$('.open_float_css').attr('href',href);
		});
	});
}

$('#div_sentaku_load').on('click', '.zaiko_box_sentaku_load_click',load_goods_data);


//-------------------------------------
//	商品写真小写真　セレクト
//	ついでに選択項目も変更する
//	2016年7月変更部分
//-------------------------------------
//データのリカバリ
var recovery_img = function () {  
	//メインのイメージを書き戻し
//	$('#top_photo').attr("src",$('#top_photo').data("src"));
//	$('#top_photo_comment').html($('#top_photo').data("txt"));
	$('#select_photo').hide();
}

//データの保存&書き換え
var save_and_replace_img = function () {  
	//データの保存
//	$('#top_photo').data("src",$('#top_photo').attr("src"));
//	$('#top_photo').data("txt",$('#top_photo_comment').html());

	//メインのイメージを書き換え
//	$('#top_photo').attr("src",$("img",this).attr("src"));
//	$('#top_photo_comment').html($(this).data("txt"));

	var offset = $("img",this).offset();
	if($('#main2').length){
		var m2offiset = $('#main2').offset();
	}
	if($('#main2_width_fix4goods_page').length){
		var m2offiset = $('#main2_width_fix4goods_page').offset();
	}

	$('#select_photo').attr("src",$("img",this).attr("src"));

	$('#select_photo').fadeIn(100);
	$('#select_photo').css("top",offset.top-30);
//	$('#select_photo').css("top",offset.top-30- m2offiset.top);

	$('#select_photo').css("left",offset.left+20);

	//スマホで横にはみ出る問題解決
	var left = offset.left+20;
	var width = $('#select_photo').width();
	var disp_size = $(window).width();
	if(disp_size < (left+width)){
		var new_left = disp_size - width;
		$('#select_photo').css("left",new_left);

	}

	//セレクトボックスの書き換え
//	var sel = $(this).data("select");
//	$('.rem').val(sel);
}  

//$("#div_parents").hover(recovery_img);
$("#tairyou").hover(recovery_img);


$(".zaiko_box").hover(save_and_replace_img,recovery_img);
$(".zaiko_box").click(save_and_replace_img);

$("body").append("<img id='select_photo' />");


//-------------------------------------
//	在庫の箱の縦幅を揃える
//-------------------------------------
$(".zaiko_right_box").each(function(){
	$(this).height($(this).prev(".zaiko_left_box").height());
});

//-------------------------------------
//	この商品のレビューを書くを携帯対応に
//	2016年7月変更部分
//-------------------------------------
	var gid;
	gid = $("#div_hyouka3").data("goods_id");
	if(chk_device() == "sumaho"){
		$("#div_hyouka3 a").attr("src","https://www.tirakita.com/cgi-bin/koe.php?syouhin_no="+gid+"&csrf="+$("#csrf").val());
	}

//-------------------------------------
//	お買い物案内をajaxload
//	日本語、英語両対応
//	2016年7月変更部分
//-------------------------------------
$(function(){
	if($("#lang").val() == "en_US"){
		$("#okaimono_201607").load("https://www.tirakita.com/okaimono_201607e.shtml?csrf="+$("#csrf").val());
	}else{
		$("#okaimono_201607").load("https://www.tirakita.com/okaimono_201607.shtml?csrf="+$("#csrf").val());
	}
});

//-------------------------------------
//	その商品をほしい物リストに入れる-商品ページ
//-------------------------------------
	$('#div_sentaku_load').on('click', '.hoshii_button', function(){
		var gid =  $(this).data("gid");
		var select_box_id =  $(this).data("select_box_id");
		var rem =  $("#"+select_box_id+" option:selected").val();
		$(this).parent().load("https://www.tirakita.com/sys/HP_Make/add_goods_hoshiimono_list_ajax.php?goods_id="+gid+"&rem="+rem+"&select_box_id="+select_box_id+"&csrf="+$("#csrf").val());
	});

//-------------------------------------
//	その商品をほしい物リストに入れる-中カタ、検索ページ
//-------------------------------------
	$('.cart_heart').click(function(){
		var gid = $(this).data('gid');
		$(this).load('https://www.tirakita.com/sys/HP_Make/add_goods_hoshiimono_list_ajax.php?mode=mcata&goods_id='+gid+'&csrf='+$('#csrf').val());
	});

//-------------------------------------
//	その商品をほしい物リストに入れる-商品ページ 下部にくっつくカート用
//-------------------------------------
	$('.cart_heart4bottom').click(function(){
		var gid = $(this).data('gid');
		$(this).load('https://www.tirakita.com/sys/HP_Make/add_goods_hoshiimono_list_ajax.php?mode=gpage4bottom&goods_id='+gid+'&csrf='+$('#csrf').val());
	});


});


//-------------------------------------
//	Youtube Ajax loopプレイヤー
//	2017年3月23日
//	#youtube_loop_playerがないとロードされない
//<div id="youtube_loop_player" data-unmute='unmute' data-videoid='BrpIRBW4g0A'></div>
//-------------------------------------
$(function(){
	if($("#youtube_loop_player").length){
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

});
 
// YouTubeの埋め込み
var ytPlayer;
var VideoID = $()
function onYouTubeIframeAPIReady() {

  ytPlayer = new YT.Player(
    'youtube_loop_player', // 埋め込む場所の指定
    {
      width: '100%', // プレーヤーの幅
      height: 240, // プレーヤーの高さ
      videoId: $('#youtube_loop_player').data('videoid'), // YouTubeのID
      playerVars: {
        controls: 0, // コントロールバーを表示しない
        showinfo: 0, // 動画情報を表示しない
				rel:0         // 関連動画の有無(default:1)
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    }
  );
}
 
// プレーヤーの準備ができたとき
function onPlayerReady(event) {
  // 動画再生
  event.target.playVideo();
	if(!$('#youtube_loop_player').data("unmute")){  ytPlayer.mute();}/* ミュート */
	else																					{  ytPlayer.unMute();}
}

// プレーヤーの状態が変更されたとき
function onPlayerStateChange(event) {
  // 現在のプレーヤーの状態を取得
  var ytStatus = event.target.getPlayerState();
  // 再生終了したとき
  if (ytStatus == YT.PlayerState.ENDED) {
    ytPlayer.playVideo();
  }
}

//-------------------------------------
//	画面の下にくっつくカート
//-------------------------------------
$(function(){

	$(window).scroll(function(){

		//携帯サイズでないとカートがでないように
		if(window.innerWidth > 768){
			$("#bottom_cart").hide();
			return;
		}

		var len = $("#bottom_cart_place").length;
		if(!len) return;

		var off = $("#bottom_cart_place").offset()
		var bottom_cart_place_top = off.top+$("#bottom_cart_place").height();
		var scr_count = $(document).scrollTop();

		//div_osusume_boxが見えたらカートを消す
		var off = $("#div_osusume_box").offset()
		var triggerNodePosition = off.top - $(window).height();
		// 現在のスクロール位置が引き金要素の位置より下にあれば‥
		if (scr_count > triggerNodePosition) {
		    // なんらかの命令を実行
			$("#bottom_cart").fadeOut(500);
			return;
		}

		if(scr_count > 200){
			$("#bottom_cart").css("display", "flex");
		} 

		if((scr_count+$(window).height()) > bottom_cart_place_top){
			$("#bottom_cart").addClass("bottom_cart_relative");
		}else{
			$("#bottom_cart").removeClass("bottom_cart_relative");
		}
	});

});

//-------------------------------------
//	英語のバナーに差し替え
//-------------------------------------
$(function(){
	if($("#lang").val() == "en_US"){
		$(".e_chg_photo").each(function(){
			var src = $(this).attr("src")
			src = src.replace(".png","e.png");
			$(this).attr("src",src);
		});
	}

	$(".tel_ask").hide();

});

//-------------------------------------
//	コメントの編集
//-------------------------------------
function disp_flip(id){
	var div = document.getElementById(id);
	if(div){
		if(div.style.display === 'block'){
			div.style.display = 'none';
		}else{
			div.style.display = 'block';
		}
	}
}

//-------------------------------------
//	左側カートの出現消滅
//-------------------------------------
$(function(){
	$(window).scroll(function(){
		if(!$('#right_cart_div').length) return;

	  var t = $('#right_cart_div').offset().top; // ターゲットの位置取得

	  var scroll_top = $(window).scrollTop();
	  var scroll_bottom = $(window).scrollTop() + $(window).height();  // 画面下部からのターゲットの位置

		if(((scroll_top-400) < t) && ((scroll_bottom+400) > t)){
	    $('#right_fixed_cart').fadeOut(300); // ボタンを非表示
	  }else{
	    $('#right_fixed_cart').fadeIn(300); // ボタンを表示
	  }
	})
});


//-------------------------------------
//	商品ページの上部に表示される管理画面バーを表示するJS
//-------------------------------------
$(function() {
	var nav = $('#tirakita_control_panel');
	$('li', nav).mouseover(function(e) {
		$('ul', this).stop().fadeIn(200);
	})
	.mouseout(function(e) {
		$('ul', this).stop().fadeOut(200);
	});
});


//-------------------------------------
//	2022年12月18日 携帯を縦1ラインにし、モダンな感じに変更
//	一番上に出る商品写真のOwl Carousel
//-------------------------------------
$(function(){

	$('#goods_photo_owl_carousel').owlCarousel({
		loop:true,
		margin:10,
		nav:true,
		pullDrag: false,
		autoplayHoverPause:true,
		lazyLoad: true,
		lazyEffect : "fade",
		responsive:{
	     0:{
	         items:1
	     },
	     600:{
	         items:3
	     },
	     1000:{
	         items:5
	     }
		}
	});
});

//-------------------------------------
//	2022年12月18日 在庫切れをOwl Carouselに
//-------------------------------------
$(function(){

	$('#zaikogire_owl_carousel').owlCarousel({
		loop:false,
		margin:10,
		lazyEffect : "fade",
		lazyLoad: true,
		responsive:{
	     0:{
	         items:3.5
	     },
	     600:{
	         items:3.5
	     },
	     1000:{
	         items:5.5
	     }
		}
	});
});



//-------------------------------------
//	2021年4月23日　商品ページのパンくずリストの表示数
//	お客様か、スマホか、事務所かで表示数を変更
//-------------------------------------
$(function(){
	var lp = 0;
	var rcrumbs_max_disp = parseInt($('#rcrumbs_max_disp').val());
	$('.rcrumbs').each(function(){
		lp++;
		if(lp > rcrumbs_max_disp) $(this).hide();
	});
});

//-------------------------------------
//	2021年4月23日　白背景写真をAI生成する
//-------------------------------------
$(function(){
	$('.ai_white_jpg_make').click(function(){
		var gid = $(this).data('gid');
		var $this = $(this);

		var parent = $this.parent();
		$this.replaceWith("<img src='https://www.tirakita.com/Gif/ajax-loader.gif'>");

		$.ajax({
			type: "get",
			url: "https://www.tirakita.com/sys/remove_background_by_ai.php",
			dataType: "text",
			async: true,
			data: {
				goods_id:gid,
			},
			success: function(text){
				parent.html(text);
			}
		});
	});
});

//-------------------------------------
//	2021年4月23日　白背景写真を1枚目からそのままコピー
//-------------------------------------
$(function(){
	$('.use_1st_photo_as_white_img').click(function(){
		var gid = $(this).data('gid');
		var $this = $(this);

		var parent = $this.parent();
		$this.replaceWith("<img src='https://www.tirakita.com/Gif/ajax-loader.gif'>");

		$.ajax({
			type: "get",
			url: "https://www.tirakita.com/sys/use_1st_photo_as_white_img.php",
			dataType: "text",
			async: true,
			data: {
				goods_id:gid,
			},
			success: function(text){
				parent.html(text);
			}
		});
	});
});

//-------------------------------------
//	2021年4月23日　白背景写真を1枚目からそのままコピーを一括で
//-------------------------------------
$(function(){
	$('.use_all_1st_photo_as_white_img').click(function(){
		console.log('cloici');
			$('.use_1st_photo_as_white_img').trigger('click');
	});
});

//-------------------------------------
//	2023年11月1日　アンカーリンクをクリックしたときにLazyがあっても位置をずれなくする
//-------------------------------------
$(function(){

	$('a[href^="#"]').click(function(e) {
		e.preventDefault();

		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;

		$.when(
			$("html, body").animate({
				scrollTop: position
			}, 700, "swing"),
		).done(function() {
			var diff = target.offset().top;
			if (diff === position) {
			} else {
				$("html, body").animate({
					scrollTop: diff
				}, 10, "swing");
			}
		});
	});
});

